import {baseTpaMetaData} from './baseTpaMetaData'
export const tpaWidgetMetaData = {
    nickname: baseTpaMetaData.nickname,
    isRepeatable: baseTpaMetaData.isRepeatable,
    isPublicContainer: false
}
